import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import AppMenuitem from './AppMenuitem';
import { MenuProvider } from './context/menucontext';
import { APP_MENU_MODEL } from '@/shared/auth/app-menu-model';
import { filterMenuByPermissions } from '@/shared/auth/menu-permissions';
import { useSessionPermissions } from '@/shared/auth/use-has-any-authority';
const AppMenu = () => {
    const permissions = useSessionPermissions();
    const model = useMemo(() => filterMenuByPermissions(APP_MENU_MODEL, permissions), [permissions]);
    return (_jsx(MenuProvider, { children: _jsx("ul", { className: "layout-menu", children: model.map((item, i) => {
                return !item?.seperator ? (_jsx(AppMenuitem, { item: item, root: true, index: i }, item.label)) : (_jsx("li", { className: "menu-separator" }, `sep-${i}`));
            }) }) }));
};
export default AppMenu;
